import {Navigate, Route} from "react-router";
import {RequireAuth} from "../authentication/routing/RequireAuth";
import {Supplier360Layout} from "../pages/supplier-360/Supplier360Layout";
import {SupplierRegistryPage} from "../pages/supplier-360/SupplierRegistryPage";
import {SupplierDetailLayout} from "../pages/supplier-360/SupplierDetailLayout";
import {SupplierOverviewTab} from "../pages/supplier-360/tabs/SupplierOverview/SupplierOverviewTab";
import {SupplierTransactionsTab} from "../pages/supplier-360/tabs/SupplierTransactions/SupplierTransactionsTab";
import {SupplierContractsTab} from "../pages/supplier-360/tabs/SupplierContracts/SupplierContractsTab";
import {SupplierOpportunitiesTab} from "../pages/supplier-360/tabs/SupplierOpportunities/SupplierOpportunitiesTab";
import {SupplierComplianceTab} from "../pages/supplier-360/tabs/SupplierCompliance/SupplierComplianceTab";
import {ComplianceRecordDetail} from "../pages/supplier-360/tabs/SupplierCompliance/components/recordDetail/ComplianceRecordDetail";
import {SupplierInsightsTab} from "../pages/supplier-360/tabs/SupplierInsights/SupplierInsightsTab";
import {SupplierValueChainTab} from "../pages/supplier-360/tabs/SupplierValueChain/SupplierValueChainTab";
import {ValueChainCreditsPage} from "../pages/supplier-360/tabs/SupplierValueChain/creditsPage/ValueChainCreditsPage";
import {routes} from "./routes";

export const supplier360Route = (
    <Route path={routes.supplier_360} element={<RequireAuth><Supplier360Layout/></RequireAuth>}>
        <Route index element={<SupplierRegistryPage/>}/>
        <Route path=":supplierId" element={<SupplierDetailLayout/>}>
            {/* No tab segment, or an unrecognized one, both redirect to overview. */}
            <Route index element={<Navigate to="overview" replace/>}/>
            <Route path="overview" element={<SupplierOverviewTab/>}/>
            <Route path="transactions" element={<SupplierTransactionsTab/>}/>
            <Route path="contracts" element={<SupplierContractsTab/>}/>
            <Route path="opportunities" element={<SupplierOpportunitiesTab/>}/>
            <Route path="compliance" element={<SupplierComplianceTab/>}/>
            <Route path="insights" element={<SupplierInsightsTab/>}/>
            <Route path="value-chain" element={<SupplierValueChainTab/>}/>
            <Route path="*" element={<Navigate to="../overview" replace/>}/>
        </Route>
        {/* A compliance record's own page — outside the supplier layout (no header, KPIs or tabs). */}
        <Route path=":supplierId/compliance/:recordId" element={<ComplianceRecordDetail/>}/>
        {/* Value chain credits (balance, pending request, companies mapped) — also its own page. */}
        <Route path=":supplierId/value-chain/credits" element={<ValueChainCreditsPage/>}/>
    </Route>
);

/** Old Supplier Normalization links (page retired with m_sp_review) land on the Supplier 360 registry.
 *  Supported through march 2027; remove this redirect after that. */
export const legacySupplierNormalizationRedirect = (
    <Route path={routes.legacy_supplier_normalization}
           element={<Navigate to="../../supplier-360" relative="path" replace/>}/>
);
